import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import CopyToClipboardIcon from "@mui/icons-material/ContentCopy";
import { RaRecord, useRecordContext } from "react-admin";

export function CopyIdIntoClipboardMenuItem(props: { record?: RaRecord; closeMenu: () => void }) {
  const { closeMenu } = props;
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }
  return (
    <MenuItem
      onClick={async () => {
        closeMenu();
        await navigator.clipboard.writeText(record.id.toString());
        showSuccessToast("ID in die Zwischenablage kopiert.");
      }}
    >
      <ListItemIcon>
        <CopyToClipboardIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Kopiere ID in die Zwischenablage</ListItemText>
    </MenuItem>
  );
}
